<script lang="ts" setup>
import { debounce } from '@antfu/utils';
import type { Ref } from 'vue';
import type { CheckboxFilter } from '~/types/Catalog';

const props = defineProps<{ filter: CheckboxFilter }>();
const route = useRoute();

const activeItems: Ref<string[]> = ref([]);
const isShowAllItems = ref(false);

onMounted(() => {
  activeItems.value = props.filter.options.filter((o) => o.state).map((o) => String(o.value));
});

async function handleFilterChange() {
  const filterSlug = `filter[${props.filter.slug}]`;
  const filterValue = activeItems.value.map((item) => item).join(';');
  const query = structuredClone(route.query);

  if (query.page) delete query.page;

  if (filterValue) {
    await navigateTo({
      path: route.path,
      query: { ...query, [filterSlug]: filterValue },
    });
  } else if (query[filterSlug]) {
    delete query[filterSlug];

    await navigateTo({
      path: route.path,
      query,
    });
  }
}

watch(
  () => route.query,
  () => {
    const query = structuredClone(route.query);

    if (query['filter[search]']) {
      delete query['filter[search]'];
    }

    if (query[`filter[${props.filter.slug}]`]) {
      activeItems.value = String(query[`filter[${props.filter.slug}]`]).split(';');
    } else if (Object.keys(query).length === 0 || !query[`filter[${props.filter.slug}]`]) {
      activeItems.value = [];
    }
  },
);

const debouncedFilterChangeHandler = debounce(800, handleFilterChange);

function onChange(checkedItem: string) {
  const index = activeItems.value.findIndex((item) => item === checkedItem);

  if (index === -1) {
    activeItems.value.push(checkedItem);
  } else {
    activeItems.value.splice(index, 1);
  }

  debouncedFilterChangeHandler();
}
</script>

<template>
  <div
    class="checkbox-filter"
    @change="onChange($event.target?.id)"
  >
    <Checkbox
      v-for="item in filter.options.slice(0, 6)"
      :id="String(item.value)"
      :key="item.value"
      v-model="item.state"
    >
      {{ item.text }}
    </Checkbox>

    <FoldableBlock v-model="isShowAllItems">
      <div class="checkbox-filter">
        <Checkbox
          v-for="item in filter.options.slice(6)"
          :id="String(item.value)"
          :key="item.value"
          v-model="item.state"
        >
          {{ item.text }}
        </Checkbox>
      </div>
    </FoldableBlock>

    <button
      v-if="filter.options.length > 5"
      class="w-fit text-hell-black-60 text-sm mt-2"
      @click="isShowAllItems = !isShowAllItems"
    >
      {{ isShowAllItems ? 'Скрыть' : 'Показать все' }}
    </button>
  </div>
</template>

<style lang="scss" scoped>
.checkbox-filter {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
</style>
